<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'政策申报发布审核',goback:true},{name:'政策资讯发布审核详情'}]" :title="'政策资讯发布审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                     <div class="child">
                      <div class="name">账号：</div>
                      <div class="content">{{ detailInfo.createUserName || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                      <div class="name">账号类型：</div>
                      <div class="content">{{ detailInfo.userVo.userTypeName }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">姓名：</div>
                      <div class="content">{{ detailInfo.createName || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                      <div class="name">邮箱：</div>
                      <div class="content">{{ detailInfo.userVo.email || '--' }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8" v-if="detailInfo.userVo">
                    <div class="child">
                      <div class="name">联系地址：</div>
                      <div class="content">{{ detailInfo.userVo.contactAddress || '--' }}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="政策资讯信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">政策资讯标题：</div>
                            <div class="content">{{detailInfo.title}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">适用行业：</div>
                            <div class="content">
                               <span v-for="(item,i) in detailInfo.industry"> {{item.value}}</span>
                            </div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">适用地区：</div>
                            <div class="content">{{detailInfo.provinceValue+detailInfo.cityValue+detailInfo.areaValue}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">资讯详情：</div>
                            <ul class="content">
                                <li v-for=" (item,i) in detailInfo.guidelinesDetails" :key="i">
                                    <div v-if="item.type == 'text'" v-html="item.content" class="super_p"></div>
                                    <img v-if="item.type == 'url'" style="max-width:100%" :src="detailInfo.frontPath+item.content" />
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,i) in detailInfo.fileList" :key="i">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detailInfo.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detailInfo:{
               userVo:{
                    userName:'',
                    userTypeName:'',
                    realName:'',
                    email:'',
                    contactAddress:'',
                },
                title:'',
                areaValue:'',
                guidelinesDetails:'',
                createTime:'',
                createUserName:'',
                modifyUserName:'',
                updateTime:'',
                fileList:[],
                checkStatusValue:'',
                checkExplanation:""
            },//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
      center: {}, //地图中心点
			maker: {}, //标记点
			zoom: 15, //缩放等级
        }
    },
    methods:{
      ready() {
			let map = new BMap.Map("mapShow");    
			let point = new BMap.Point(this.center.lng, this.center.lat);    
			map.centerAndZoom(point, 16);    
			map.enableScrollWheelZoom(true);
			map.enableDoubleClickZoom(true);
			let marker = new BMap.Marker(point);        // 创建标注    
			map.addOverlay(marker);                     // 将标注添加到地图中 
		},
        open(){
          this.$alert('点击附件')
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/policy/guidelines/reviewLog/details/'+this.id)
          if (code == 200) {            
              this.detailInfo = data
              if(this.detailInfo.fileList.length > 0){
                  if(!this.detailInfo.fileList[0].frontPath){
                      let value = []
                      this.detailInfo.fileList.map(val=>{
                          value.push({fileName:val.fileName,filePath:val.filePath,frontPath:this.detailInfo.frontPath})
                      })
                      this.detailInfo.fileList = value
                  }
              }
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>